var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 1.49996C0.666687 1.03972 1.03978 0.666626 1.50002 0.666626H7.33335C7.79359 0.666626 8.16669 1.03972 8.16669 1.49996V7.33329C8.16669 7.79353 7.79359 8.16663 7.33335 8.16663H1.50002C1.03978 8.16663 0.666687 7.79353 0.666687 7.33329V1.49996ZM1.50002 1.49996V7.33329H7.33335V1.49996H1.50002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 10.6666C0.666687 10.2064 1.03978 9.83329 1.50002 9.83329H7.33335C7.79359 9.83329 8.16669 10.2064 8.16669 10.6666V16.5C8.16669 16.9602 7.79359 17.3333 7.33335 17.3333H1.50002C1.03978 17.3333 0.666687 16.9602 0.666687 16.5V10.6666ZM1.50002 10.6666V16.5H7.33335V10.6666H1.50002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83335 1.49996C9.83335 1.03972 10.2065 0.666626 10.6667 0.666626H16.5C16.9603 0.666626 17.3334 1.03972 17.3334 1.49996V7.33329C17.3334 7.79353 16.9603 8.16663 16.5 8.16663H10.6667C10.2065 8.16663 9.83335 7.79353 9.83335 7.33329V1.49996ZM10.6667 1.49996V7.33329H16.5V1.49996H10.6667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83335 10.6666C9.83335 10.2064 10.2065 9.83329 10.6667 9.83329H16.5C16.9603 9.83329 17.3334 10.2064 17.3334 10.6666V16.5C17.3334 16.9602 16.9603 17.3333 16.5 17.3333H10.6667C10.2065 17.3333 9.83335 16.9602 9.83335 16.5V10.6666ZM10.6667 10.6666V16.5H16.5V10.6666H10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllWidgets);
export default __webpack_public_path__ + "static/media/AllWidgets.f96e7f89136193f666ebca0981c7e621.svg";
export { ForwardRef as ReactComponent };